import { isMobile } from "react-device-detect";
import sha256 from 'crypto-js/sha256';

var digitalData = {
    versionDL: "20230622_4.1.1",
    pageInstanceID: "",
    page: {
        pageInfo: {
            pageName: "",
            pageMode: "",
            pageIntent: "",
            pageSegment: "",
            sysEnv: "",
            version: "",
            channel: "",
            language: "",
            geoRegion: "",
            level1: "",
            level2: "",
            level3: "",
            level4: "",
            level5: "",
            level6: "",
            level7: "",
            level8: "",
            level9: "",
            level10: "",
            area: "",
            server: window.location.hostname,
            businessUnit: "",
            siteAppName: "",
            projectName: "",
            errorPage: ""
        },
        pageActivity: {
            search: {
                onSiteSearchResults: "",
                onSiteSearchTerm: "",
                onSiteSearchEnterTerm: ""
            },
            link: {
                name: "",
                url: "",
                ext: "",
                aux1: "",
                aux2: "",
                aux3: ""
            },
            video: {
                nameOfVideoDisplayed: "",
                duration: "",
				id: "",
				player: "",
				quality: "",
				url: ""
            },
            audio: {
                nameOfPodcastDisplayed: "",
                duration: "",
				id: "",
				player: "",
				quality: "",
				url: ""
            },
            loginType: ""
        },
    },
    optimization: {
        attributes: [],
        event: {
            eventName: "",
            optimizationEvent: ""

        }
    },
    internalCampaign: {
        attributes: [],
        event: {
            eventInfo: {
                eventName: "",
                siteActionName: ""
            },
        },
    },
    user: {
        device: {
            userAgent: "",
            mobile: "",
            root: "",
            mode: "",  
			IPAddress: "",          
			advertisingID: ""
        },
        consent:{
			advertising: "",
			analytics: "",
			optimization: "",
			version: "",
			technique: ""
   		},
        userScoring: "",
        userState: "",
        IDs:[],
		e: "", 
		p: "", 
        gClientID: "",
		secondaryCIF: "",       
        segment: {
            global: "",
            profile: "",
            collectiveID: "", 
	    	digitalizationLevel: ""
        },
        gender: "",
        country: "",
        state: "",
        age: "",
        civilStatus: "",
        educationLevel: "",
        jobType: ""
    },
    application: {
        transactionID: "",
        application: {
            type: "",
            name: ""
        },
        fulfillmentModel: "",
        typology: "",
        programTypeHired: "",
        offer: "",
        operationNumber: "",
        process: "",
        step: "",
        interactionLevel: "",
        isQualifiedVisits: "",
        state: "",
        errorType: "",
        earnings: "",
        expenses: "",
        customFields: "",
        globalApplication: ""
    },
    products: {
        attributes: [{
            primaryCategory: "",
            productSubtype: "",
            productName: "",
            productCode: "",
            quantity: "",
            amount: "",
            paymentAmount: "",
            numberOfPayments: "",
            paymentDate: "",
            paymentType: "",
            serviceCharge: "",
            currency: "",
            numberOfHolders: "",
            interestRate: {
                tin: "",
                tae: "",
                rate: ""
            },
            term: "",
            group: "",
            state: ""
        }],
        productPortfolio: []
    },
    activationTools: {
		adobeAnalytics: "",
		googleAnalytics: "",
		meta: "",
		googleAds: "",
		adServer: "",
		mobileAttribution: "",
		feedback: ""
	}
};

const jsonProductsAtributes = [{
    primaryCategory: "",
    productSubtype: "",
    productName: "",
    productCode: "",
    quantity: "",
    amount: "",
    paymentAmount: "",
    numberOfPayments: "",
    paymentDate: "",
    paymentType: "",
    serviceCharge: "",
    currency: "",
    numberOfHolders: "",
    interestRate: {
        tin: "",
        tae: "",
        rate: ""
    },
    term: "",
    group: "",
    state: ""
}];

export function setVersionDL(a) {
    digitalData.versionDL = a
}

export function clonarDataLayer(sdigitalData) {
    digitalData = sdigitalData;
    window.digitalData = digitalData;
}

export function getDigitalData() {
    return digitalData;
}

export function setPageInstanceID(a) {
    digitalData.pageInstanceID = a
}

export function setPageName() {
    var area = digitalData.page.pageInfo.area;
    var pageSegment = digitalData.page.pageInfo.pageSegment;
    var levels = [];
    for (var i = 1; i < 11; i++) {
        if (digitalData["page"]["pageInfo"]["level" + i] !== "") {
            levels.push(digitalData["page"]["pageInfo"]["level" + i]);
        } else {
            break;
        }
    }
    var pageName = area + ":" + pageSegment;
    for (var j = 0; j < levels.length; j++) {
        if (j === 0) {
            pageName += ":";
        }

        if (j === levels.length - 1) {
            pageName += "" + levels[j];
        } else {
            pageName += "" + levels[j] + ":";
        }
    }
    digitalData.page.pageInfo.pageName = digitalData.page.pageInfo.sysEnv + ':' + pageName;
}

export function setPageIntent(a) {
    digitalData.page.pageInfo.pageIntent = a
}

export function setPageSegment(a) {
    digitalData.page.pageInfo.pageSegment = a
}

export function setSysEnv() {
    var modeloDispositivo = '';
    if (isMobile) {
        modeloDispositivo = 'web-movil';
    } else {
        modeloDispositivo = 'escritorio';
    }
    digitalData.page.pageInfo.sysEnv = modeloDispositivo;
}

export function setVersion(a) {
    digitalData.page.pageInfo.version = a
}

export function setChannel(a) {
    digitalData.page.pageInfo.channel = a
}

export function setLanguage(a) {
    digitalData.page.pageInfo.language = a
}

export function setGeoRegion(a) {
    digitalData.page.pageInfo.geoRegion = a
}

export function setLevel(a, e) {
    switch (a) {
        case 1:
            digitalData.page.pageInfo.level1 = e;
            break;
        case 2:
            digitalData.page.pageInfo.level2 = e;
            break;
        case 3:
            digitalData.page.pageInfo.level3 = e;
            break;
        case 4:
            digitalData.page.pageInfo.level4 = e;
            break;
        case 5:
            digitalData.page.pageInfo.level5 = e;
            break;
        case 6:
            digitalData.page.pageInfo.level6 = e;
            break;
        case 7:
            digitalData.page.pageInfo.level7 = e;
            break;
        case 8:
            digitalData.page.pageInfo.level8 = e;
            break;
        case 9:
            digitalData.page.pageInfo.level9 = e;
            break;
        case 10:
            digitalData.page.pageInfo.level10 = e;
            break;
        default:
            break;
    }
}

export function setArea() {
    digitalData.page.pageInfo.area = "publica"
}

export function setServer() {
    digitalData.page.pageInfo.server = window.location.hostname;
}

export function setBusinessUnit(a) {
    digitalData.page.pageInfo.businessUnit = a
}

export function setSiteAppName(a) {
    digitalData.page.pageInfo.siteAppName = a
}

export function setErrorPage(a) {
    digitalData.page.pageInfo.errorPage = a
}

export function setEventName(a) {
    digitalData.page.optimization.event.eventName = a;
}

export function setOptimizationEvent(a) {
    digitalData.page.optimization.event.optimizationEvent = a;
}

export function setOnSiteSearchResults(a) {
    digitalData.page.pageActivity.search.onSiteSearchResults = a;
}

export function setOnSiteSearchTerm(a) {
    digitalData.page.pageActivity.search.onSiteSearchTerm = a;
}

export function setOnSiteSearchEnterTerm(a) {
    digitalData.page.pageActivity.search.onSiteSearchEnterTerm = a;
}

export function setLinkName(a) {
    digitalData.page.pageActivity.link.name = a;
}

export function setLinkUrl(a) {
    digitalData.page.pageActivity.link.url = a;
}

export function setLinExt(a) {
    digitalData.page.pageActivity.link.ext = a;
}

export function setLinkAux1(a) {
    digitalData.page.pageActivity.link.aux1 = a;
}

export function setLinkAux2(a) {
    digitalData.page.pageActivity.link.aux2 = a;
}

export function setLinkAux3(a) {
    digitalData.page.pageActivity.link.aux3 = a;
}

export function setNameOfVideoDisplayed(a) {
    digitalData.page.pageActivity.video.nameOfVideoDisplayed = a;
}

export function setNameOfPodcastDisplayed(a) {
    digitalData.page.pageActivity.audio.nameOfPodcastDisplayed = a;
}

export function setLoginType(a) {
    digitalData.page.pageActivity.loginType = a;
}

export function setInternalCampaignEvent(a) {
    digitalData.internalCampaign.event.eventInfo.eventName = "IntCmpClick";
    digitalData.internalCampaign.event.eventInfo.siteActionName = a;
}

export function setUserAgent() {
    digitalData.user.device.userAgent = navigator.userAgent;
}

export function setMobile() {
    var a = !1;
    (function (e) {
        (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge|maemo|midp|mmp|mobile.+firefox|netfront|operam(ob|in)i|palm(os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windowsce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|awa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r|s)|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp(i|ip)|hs-c|ht(c(-||_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac(|-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt(|\/)|klon|kpt|kwc-|kyo(c|k)|le(no|xi)|lg(g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-||o|v)|zz)|mt(50|p1|v)|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v)|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-|)|webc|whit|wi(g|nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e.substr(0, 4))) && (a = !0)
    }(navigator.userAgent || navigator.vendor || window.opera));
    a ? digitalData.user.device.mobile = "si" : digitalData.user.device.mobile = "no";
}

export function setRoot(a) {
    digitalData.user.device.root = a
}

export function setUserState(a) {
    digitalData.user.userState = a
}

export function setProfileID(a) {
    digitalData.user.profileID = a
}

export function setUserID(a) {
    digitalData.user.userID = a
}

export function setProspectID(a) {
    digitalData.user.prospectID = a
}

export function setSegmentGlobal(a) {
    digitalData.user.segment.global = a
}

export function setSegmentProfile(a) {
    digitalData.user.segment.profile = a
}

export function setGender(a) {
    digitalData.user.gender = a
}

export function setCountry(a) {
    digitalData.user.country = a
}

export function setState(a) {
    digitalData.user.state = a
}

export function setAge(a) {
    digitalData.user.age = a
}

export function setCivilStatus(a) {
    digitalData.user.civilStatus = a
}

export function setEducationLevel(a) {
    digitalData.user.educationLevel = a
}

export function setJobType(a) {
    digitalData.user.jobType = a
}

export function setTransactionID(a) {
    digitalData.application.transactionID = a
}

export function setApplicationType(a) {
    digitalData.application.application.type = a
}

export function setApplicationName(a) {
    digitalData.application.application.name = a
}

export function setFulfillmentModel(a) {
    digitalData.application.fulfillmentModel = a
}

export function setTypology(a) {
    digitalData.application.typology = a.toLowerCase()
}

export function setProgramTypeHired(a) {
    digitalData.application.programTypeHired = a
}

export function setOffer(a) {
    digitalData.application.offer = a
}

export function setOperationNumber(a) {
    digitalData.application.operationNumber =(a)? a.toString():"";
}

export function setProcess(a) {
    digitalData.application.process = a.toLowerCase()
}

export function setApplicationStep(a) {
    digitalData.application.step = a.toLowerCase()
}

export function setInteractionLevel(a) {
    digitalData.application.interactionLevel = a;
}

export function setApplicationState(a) {
    digitalData.application.state = a.toLowerCase()
}

export function setApplicationErrorType(a) {
    digitalData.application.errorType = a.toLowerCase()
}

export function setEarnings(a) {
    digitalData.application.earnings = a.toLowerCase()
}

export function setExpenses(a) {
    digitalData.application.expenses = a.toLowerCase()
}

export function setCustomFields(a) {
    digitalData.application.customFields = a.toLowerCase()
}

export function setGlobalApplication(a) {
    digitalData.application.globalApplication = a.toLowerCase()
}

export function setPrimaryCategory(a) {
    validarProductsVacio();
    digitalData.products.attributes[0].primaryCategory = a;
}

export function setProductSubtype(a) {
    validarProductsVacio();
    digitalData.products.attributes[0].productSubtype = a;
}

export function setProductName(a) {
    validarProductsVacio();
    digitalData.products.attributes[0].productName = a;
}

export function setCurrency(a) {
    validarProductsVacio();
    digitalData.products.attributes[0].currency = a;
}

export function setProductState(a) {
    validarProductsVacio();
    digitalData.products.attributes[0].state = a;
}

export function setIsQualifiedVisits(a) {
    digitalData.application.isQualifiedVisits = a.toLowerCase()
}

export function setProductsAtributes(a) {
    digitalData.products.attributes = a;
}

export function setAplication(a) {
    digitalData.application = a;
}

export function setEmail(a){
	(a) ? digitalData.user.e = sha256(a.toLowerCase().trim()).toString() : digitalData.user.e = "";
}

export function setPhone(a){
	(a) ? digitalData.user.p = sha256('+51'+a.toLowerCase().trim()).toString() : digitalData.user.p = "";
	
}

function validarProductsVacio() {
    digitalData.products.attributes = digitalData.products.attributes || jsonProductsAtributes;
}